export enum CreateConsultSteps {
  First = '1',
  Second = '2',
  Third = '3',
  Forth = '4',
}

export type CreateConsultStepsData = {
  [Step in CreateConsultSteps]: {
    component: () => JSX.Element;
    path?: string;
  };
};
